import Map from './Map';
import toggleMap from './map_toggle';

const zoomToBounds = (map: Map, bounds): void => {
  map.map.fitBounds(bounds, 80);
};

const callback = (): void => {
  const mapElements = document.querySelectorAll('.map-canvas');

  mapElements.forEach((mapElement: HTMLElement) => {
    const goBackLabel = mapElement.dataset.goBackLabel || 'Go Back';
    const { mapZoom, detailedMarkers, shouldZoomToBounds } = mapElement.dataset;
    const pointsOfInterest = JSON.parse(mapElement.dataset.pointsOfInterest);

    if (!pointsOfInterest.length) return;

    const map: Map = new Map();
    const placeData = {
      center: {
        lat: Number(pointsOfInterest[0].latitude),
        lng: Number(pointsOfInterest[0].longitude),
      },
      zoom: Number(mapZoom) || 12,
    };

    map.loadGoogleMaps().then((googleMaps): void => {
      map.createMap(googleMaps, mapElement, placeData);
    }).then((): void => {
      const bounds = new map.googleMaps.LatLngBounds();

      pointsOfInterest.forEach((pointOfInterest): void => {
        const {
          latitude,
          longitude,
          name,
          type,
          showAddress,
        } = pointOfInterest;

        if (showAddress) {
          if (detailedMarkers) {
            const marker = map.addLinkMarker(pointOfInterest, type);
            bounds.extend(marker.getPosition());
          } else {
            const marker = map.addMarker(latitude, longitude, name);
            bounds.extend(marker.getPosition());
          }
        }
      });

      if (pointsOfInterest.length > 1) {

        // Should this just be set as an option in the partial?
        const toggleElement = document.querySelector(`.map-toggle[data-map-target="#${mapElement.id}"]`);
        if (toggleElement) {
          toggleMap(toggleElement, goBackLabel, () => zoomToBounds(map, bounds));
        }

        if (shouldZoomToBounds) {
          zoomToBounds(map, bounds);
        }
      }
    });
  });
};
window.onload = (): void => {
  callback();
};
